import { Editor, Location, Range } from 'slate';

export const ELEMENT_H1 = 'h1';
export const ELEMENT_H2 = 'h2';
export const ELEMENT_H3 = 'h3';
export const ELEMENT_H4 = 'h4';
export const ELEMENT_H5 = 'h5';
export const ELEMENT_H6 = 'h6';
export const ELEMENT_PARAGRAPH = 'p';
export const ELEMENT_TABLE = 'table';
export const ELEMENT_TH = 'th';
export const ELEMENT_TR = 'tr';
export const ELEMENT_TD = 'td';

export const ELEMENT_UL = 'ul';
export const ELEMENT_OL = 'ol';
export const ELEMENT_LI = 'li';

export const isExpanded = (range?: Range | null) => !!range && Range.isExpanded(range);

export const getText = (editor: Editor, at?: Location | null) =>
  (at && Editor.string(editor, at)) ?? '';

export const getSelectionText = (editor: Editor) => getText(editor, editor.selection);

export const isSelectionExpanded = (editor: Editor) => isExpanded(editor.selection);
